import React from "react";

// MUI Imports
import TableBody from "@mui/material/TableBody";

// Component Imports
import ResultRowProperty from "./ResultRowProperty";

const ResultTableBodyProperty = ({
  brandId,
  propertyResult
}) => {
  return (
    <TableBody className="table-background-color">
      {propertyResult ? 
        (
          <ResultRowProperty
            brand={brandId} 
            row={propertyResult}
          />
        ) : (
          null
        )
      }
    </TableBody>
  );
};

export default ResultTableBodyProperty;
